import axios, { AxiosResponse } from "axios";
import { IBooking, IListQueryParams, ILocker } from "../types/types";

import { ENV } from "../constants/environment.base";

export class BookingService {
  private readonly API_ROUTE_PREFIX: string = "booking";
  private readonly API_PREFIX: string =
    this.API_ROUTE_PREFIX !== ""
      ? `${ENV.API_ENDPOINT}/${this.API_ROUTE_PREFIX}`
      : ENV.API_ENDPOINT;

  /**
   * List bookings
   *
   * @returns Promise with bookings response
   */
  public list: (
    params?: IListQueryParams
  ) => Promise<AxiosResponse<{ data: IBooking[] }>> = (params) => {
    return axios.get(`${this.API_PREFIX}/list`, {
      params,
    });
  };

  /**
   * Get booking
   */
  public get: (id: string) => Promise<AxiosResponse<{ data: IBooking }>> = (
    id
  ) => {
    return axios.get(`${this.API_PREFIX}/${id}`);
  };

  /**
   * Check booking availability
   */
  public availability: () => Promise<
    AxiosResponse<{
      [usage: string]: {
        [size: string]: number;
      };
    }>
  > = () => {
    return axios.post(`${this.API_PREFIX}/availability`);
  };

  /**
   * Start booking
   *
   * @returns Promise with booking setup response
   */
  public start: (data: {
    usage: ILocker["usage"];
    size: ILocker["size"];
    payment_method: string;
  }) => Promise<
    AxiosResponse<{
      data: IBooking;
    }>
  > = (data) => {
    return axios.post(`${this.API_PREFIX}/start`, { data });
  };

  /**
   * Get booking credentials
   *
   * @returns Promise with booking credentials response
   */
  public credentials: (booking_id: string) => Promise<
    AxiosResponse<{
      data: {
        keycode: string;
        pincode: string;
      };
    }>
  > = (booking_id) => {
    return axios.post(`${this.API_PREFIX}/credentials/${booking_id}`);
  };

  /**
   * End booking
   *
   * @returns Promise with booking setup response
   */
  public end: (id: string) => Promise<AxiosResponse<{ data: IBooking }>> = (
    id
  ) => {
    return axios.post(`${this.API_PREFIX}/end`, { id });
  };
}
